import starterConstants from "@starter/constants";
import overrideProps from "@starter/Framework/Common/Utilities/overrideProps";

export default overrideProps(starterConstants, {});

/* Store Custom Code - Start */
export const pagesToExclude = [
    "CartPage",
    "MyAccountPage",
    "ChangeCustomerPage",
    "OrderHistoryPage",
    "MyAccountPage",
    "MyListsPage",
    "SavedOrderDetailsPage",
    "SavedOrderListPage",
    "MyListsDetailsPage",
    "AccountSettingsPage",
    "AddressesPage",
    "BudgetManagementPage",
    "ChangePasswordPage",
    "CheckoutReviewAndSubmitPage",
    "CheckoutShippingPage",
    "InvoiceDetailsPage",
    "InvoiceHistoryPage",
    "OrderApprovalDetailsPage",
    "OrderApprovalListPage",
    "OrderConfirmationPage",
    "OrderDetailsPage",
    "OrderStatusPage",
    "OrderUploadPage",
    "RfqJobQuoteDetailsPage",
    "RfqJobQuotesPage",
    "RfqMyQuotesPage",
    "RfqQuoteDetailsPage",
    "RfqRequestQuotePage",
    "SavedPaymentsPage",
    "UserListPage",
    "UserSetupPage",
];
/* Store Custom Code - End */
